import { useQuery } from "@tanstack/react-query";
import ConfigHolder from "../../config/ConfigHolder";
import { apiSign } from "../../context/WidgetContext";
import useWidgetStore from "../../store/useWidgetStore";
import { useSettings } from "../../context/SettingsContext";
export const useVoucher = (options) => {
    const { api_key, widget_id } = useSettings();
    const { language, consumer } = useWidgetStore();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: false, networkMode: "always", cacheTime: 0, staleTime: 0 });
    const { getGeneratedDaoProducts, getDaoAppointments } = useWidgetStore();
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-vouchers'], queryFn: async ({ signal }) => {
            var _a, _b, _c, _d, _e, _f, _g;
            let url = new URL('/consumer/booking/api/method/getVouchers', ConfigHolder.apiBaseUrl);
            let _appointment = (_a = getDaoAppointments()[0]) !== null && _a !== void 0 ? _a : [];
            let _products = getGeneratedDaoProducts();
            const data = {
                consumerId: (_b = consumer.id) !== null && _b !== void 0 ? _b : '',
                products: JSON.stringify(_products),
                appointment: JSON.stringify(_appointment)
            };
            let api_salt = Date.now(), body = new URLSearchParams(data);
            // body: string = JSON.stringify(data) // use this to post JSON
            let _params = Object.assign(Object.assign({}, data), { applicationId: (_d = (_c = process.env) === null || _c === void 0 ? void 0 : _c.YII_API_APPLICATION_ID) !== null && _d !== void 0 ? _d : 'widget-booking', method: 'getVouchers', widget_id: widget_id });
            url.searchParams.set('api_signature', apiSign(_params, api_key, api_salt));
            url.searchParams.set('api_format', 'json');
            url.searchParams.set('api_lang', language);
            url.searchParams.set('api_salt', api_salt.toString());
            url.searchParams.set('applicationId', (_f = (_e = process.env) === null || _e === void 0 ? void 0 : _e.YII_API_APPLICATION_ID) !== null && _f !== void 0 ? _f : 'widget-booking');
            url.searchParams.set('api_key', api_key);
            url.searchParams.set('widget_id', widget_id);
            url.searchParams.set('consumerId', (_g = consumer.id) !== null && _g !== void 0 ? _g : '');
            url.searchParams.set('products', JSON.stringify(_products));
            url.searchParams.set('appointment', JSON.stringify(_appointment));
            const response = await fetch(url.href, {
                signal: signal,
                method: "GET", // this request is GET in the old widget
                // method: "POST", // this request is GET in the old widget
                headers: {
                // 'Content-Type': 'application/json', // use this to post JSON
                // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                // 'X-OAnl-csrf-protection': 'on',
                // 'accept': 'application/ld+json',
                },
                //   body: body
            });
            return response.json();
        } }));
};
